import { Component } from '@angular/core';
import { ESlideMenuOptions } from 'src/app/services/config.service';

@Component({
    selector: 'app-products-analysis',
    templateUrl: './products-analysis.component.html',
    styleUrls: ['./products-analysis.component.sass'],
    standalone: false
})
export class ProductsAnalysisComponent {


  menuItems: ESlideMenuOptions[] = [
    ESlideMenuOptions.Mch_Prices,
    ESlideMenuOptions.Mch_StockForecast,
    ESlideMenuOptions.Mch_BatchMovementReport,
  ];

}
